export const captureViewShot = () => {};
